export default __webpack_public_path__ + "static/media/first-name.4c23376a.png";